import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchNoderNodes } from '../../actions';

const Spinner = require('react-spinkit');

export class Loading extends Component {
  componentDidMount() {
    this.props.fetchNoderNodes(this.props.name);
  }

  render() {
    return (
      <div className='node' style={{
        transform: `translate3d(
          ${window.innerWidth/2-40}px,
          ${window.innerHeight/2-20}px, 0px)`}} >
        <section>loading...</section>
        <Spinner name="line-scale-pulse-out-rapid" />
      </div>
    )
  }
}

const mapDispatchToProps = {
  fetchNoderNodes
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Loading)




// WEBPACK FOOTER //
// ./src/components/Noder/Loading.js